import { Skeleton } from '@chakra-ui/react';
import { PTOType } from '@/types/api';
import { formatPtoTypeHours, iconByPTOType, ptoTypeLabel } from '@/utils/pto';
import * as Styles from './TimeOffCard.styles';

export type Variation = 'neutral' | 'primary';

const customPtoTypeLabel: { [type in PTOType]: string } = {
  ...ptoTypeLabel,
  [PTOType.PERSONAL_PAUSE]: 'Personal Time Off',
  // [PTOType.HEALTH_PAUSE]: 'Health Pauses',
};

type Props = {
  type: PTOType;
  mainHours?: number;
  scheduledHours?: number;
  isUnlimited?: boolean;
  onClick?: () => void;
  className?: string;
  title?: string;
  isLoading?: boolean;
};

const TimeOffCard = ({
  type,
  mainHours = 0,
  scheduledHours = 0,
  isUnlimited = false,
  onClick,
  className,
  title,
  isLoading = false,
}: Props): JSX.Element => {
  const mainHoursFormatProps = formatPtoTypeHours(type, mainHours);
  const scheduledHoursFormatProps = formatPtoTypeHours(type, scheduledHours);

  const variation: Variation = onClick ? 'primary' : 'neutral';

  return (
    <Styles.ButtonCard onClick={onClick} className={className} as={onClick ? 'button' : 'div'}>
      {isLoading ? (
        <Skeleton className="tw-h-3.5 tw-w-[60px] tw-my-[2.8px]" />
      ) : (
        <Styles.ButtonCardText>{title || customPtoTypeLabel[type]}</Styles.ButtonCardText>
      )}
      <div>
        {isLoading ? (
          <Skeleton className="tw-h-[26px] tw-w-[70px] tw-my-[2.6px] tw-mx-auto" />
        ) : (
          <Styles.ButtonHoursContainer $variation={variation}>
            {iconByPTOType[type]}
            <p>{mainHoursFormatProps.value}</p>
          </Styles.ButtonHoursContainer>
        )}
        {isLoading ? (
          <div className="tw-py-[3.5px]">
            <Skeleton className="tw-w-[99px] tw-h-3.5" />
          </div>
        ) : (
          <Styles.ButtonHoursAvailable $variation={variation}>
            {mainHoursFormatProps.label} {isUnlimited ? 'used' : 'available'}
          </Styles.ButtonHoursAvailable>
        )}
      </div>
      {isLoading ? (
        <Skeleton className="tw-w-[120px] tw-h-3.5 tw-my-[2.8px]" />
      ) : (
        <Styles.ButtonCardText $empty={!scheduledHoursFormatProps.value}>
          {scheduledHoursFormatProps.value
            ? `${scheduledHoursFormatProps.value} ${scheduledHoursFormatProps.label} scheduled`
            : 'No time scheduled'}
        </Styles.ButtonCardText>
      )}
    </Styles.ButtonCard>
  );
};

export default TimeOffCard;
